module.exports = __webpack_public_path__ + "img/logo_w.d08ed581.png";